import React, { Component } from 'react';

class ScrollTopButton extends Component {

    constructor(props) {
        super(props);
        this.htmlSrcElement;
        this.state = {
            scrollTopVal: 0,
            outBound: false,
            activatedOnce: false
        };

        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.handleScrollTopButtonShowHide = this.handleScrollTopButtonShowHide.bind(this);
    }

    componentDidMount() {
        /* Legacy target for scrollTop - disabled for now */
        // this.htmlSrcElement = document.documentElement;

        /* More recent HTMLElement targeting for scrollTop use - will watch for stability */
        // get document element for getting scroll value in IE11, Opera, and Chrome
        this.htmlSrcElement = document.querySelector('html,body');

        if (window.navigator.userAgent.match(/Edge/)) {
            // IE Edge target for scrollTop
            this.htmlSrcElement = document.body;
        }
        window.addEventListener('scroll', this.handleScrollTopButtonShowHide);
        window.addEventListener('load', this.handleScrollTopButtonShowHide);
    }

    /** 
     * @method handleScrollTop - Executes scrollTop iteration back down to 0.
     * @param {HTMLElement} - Supply the document.body or html element.
     * @return {integer || float} - Can return an integer or float.
     */
    handleScrollTop(srcElement) {
        //const htmlElement = document.querySelector('html');
        let sc = srcElement.scrollTop;
        /* milliseconds duration */
        let duration = 1500.00;
        /* set interval - miliseconds */
        const interval = 1.0;
        /* pixels per 1 millisecond interval */
        const pixelsIncrement = 24.0;
        /* set a rate (pixels per milliseconds) that is scaled with a pixels increment value. */
        let rate = ((sc / duration) * pixelsIncrement > 1.0) ? (sc / duration) * pixelsIncrement : 1.0;
        /* set timer and interval */
        let timer = setInterval(function () {
            scrollValueIterator(srcElement);
        }, interval);

        /* handles scroll value iterating and application inside the setInterval */
        function scrollValueIterator(element) {
            if (sc > 10.00) {
                sc -= rate;
                window.scroll({
                    top: sc,
                    left: 0,
                });
                //element.scrollTop -= rate; - might condition for mobile devices in a later release.
                //sc = element.scrollTop; - might condition for mobile devices in a later release.
            } else {
                clearTimeout(timer);
            }
        }
        /* return the adjusted scrollTop value */
        return sc;
    }
    /**
     * @method handleScrollTopButtonShowHide - Hides or shows the scrollTop button.
     * based on value conditions
     */
    handleScrollTopButtonShowHide(e) {
        this.setState({ scrollTopVal: this.htmlSrcElement.scrollTop });
        /* Is the scrollTop above 300 pixels? */
        if (this.htmlSrcElement.scrollTop > 300) {
            // then out of bounds
            this.setState({ outBound: true });
        } else {
            // otherwise in bounds
            this.setState({ outBound: false });
        }
        /* Only activate once when conditions are met - no else clause */
        if (this.state.outBound && !this.state.activatedOnce) {
            this.setState({ activatedOnce: true });
        }
        /* Only deactivate once when conditions are met - no else clause  */
        if (!this.state.outBound && this.state.activatedOnce) {
            this.setState({ activatedOnce: false });
        }
    }
    /**
     * @method handleScrollTopButtonClick - Triggers the scrollTop animation
     * @param {event} e  - The event object
     * @param {integer || float} scrollTopElement - The returned value from the scrollTop calculation.
     */
    handleScrollTopButtonClick(e, scrollTopElement) {
        const runScrollTop = this.handleScrollTop(scrollTopElement);
        return runScrollTop;
    }

    render() {
        return (
            <div className="scroll-top__container ubuntu--bold">
                <button className={(this.state.activatedOnce) ? 'btn scroll-top__button scroll-top__button--active' : 'btn scroll-top__button'} aria-label="Scroll to top" onClick={(e) => this.handleScrollTopButtonClick(e, this.htmlSrcElement)}>
                    <span>Top&nbsp;</span><i className="fas fa-angle-double-up" aria-hidden="true"></i>
                </button>
            </div>

        );
    }
}

export default ScrollTopButton;